import { render } from "./PriceChange.vue?vue&type=template&id=48261684&scoped=true"
import script from "./PriceChange.vue?vue&type=script&lang=js"
export * from "./PriceChange.vue?vue&type=script&lang=js"

import "./PriceChange.vue?vue&type=style&index=0&id=48261684&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48261684"]])

export default __exports__